import React, { Fragment, useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import {
    Button,
    Box,
    colors,
    Typography,
    Grid,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    TableRow,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    Paper
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 15,
        backgroundColor: theme.palette.background.paper,
    },
    avatar: {
        marginRight: theme.spacing(1),
        backgroundColor: colors.grey[200]
    },
    container: {
        maxHeight: 340,
    },
    input: {
        color: colors.cyan['A700']
    },
    inputErro: {
        color: colors.red[900]
    },
    products: {
        padding: 0
    }
}));

const Balance = ({ item, saldos, open, closeBalance, changeBalanceFilter }) => {

    const classes = useStyles();

    const [endDateTime, setEndDateTime] = useState(new Date());
    const [startDateTime, setStartDateTime] = useState(new Date());

    const changeStartDatetime = (value) => {
        setStartDateTime(value);
        changeBalanceFilter(value, endDateTime);
    }

    const changeEndDatetime = (value) => {
        setEndDateTime(value);
        changeBalanceFilter(startDateTime, value);
    }

    useEffect(() => {
        return
    }, []);

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Saldo de Estoque
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                            })
                        }
                        onSubmit={(values, formik) => {
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (

                            <form onSubmit={handleSubmit}>

                                <Paper className={classes.root} >
                                    <Grid container spacing={2} alignContent='flex-end' alignItems='center' >

                                        <Grid item
                                            md={8}
                                            xs={12}>
                                            <Typography variant='h3'>{item.nome}</Typography>
                                        </Grid>

                                        <Grid item
                                            md={2}
                                            xs={12}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                cancelLabel="Cancelar"
                                                id="startDateTime"
                                                name="startDateTime"
                                                label="Data Inicial"
                                                format="DD/MM/YYYY"
                                                value={startDateTime}
                                                inputVariant="outlined"
                                                onChange={changeStartDatetime}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid item
                                            md={2}
                                            xs={12}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                cancelLabel="Cancelar"
                                                id="endDateTime"
                                                name="endDateTime"
                                                label="Data Final"
                                                inputVariant="outlined"
                                                format="DD/MM/YYYY"
                                                value={endDateTime}
                                                onChange={changeEndDatetime}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                    </Grid>

                                    <Grid item
                                        md={12}
                                        xs={12}>

                                        <TableContainer component={PerfectScrollbar}>

                                            <Table stickyHeader size="medium" aria-label="a dense table">
                                                <TableHead>
                                                    <TableCell width={500} >
                                                        <Typography>Estoque</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography>Saldo Anterior</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography>Entradas</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography>Saídas</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography>Saldo</Typography>
                                                    </TableCell>
                                                </TableHead>

                                                <TableBody>
                                                    {saldos.map((item, index) => (
                                                        <TableRow style={(index === saldos.length - 1) ? { backgroundColor: '#1b1918' } : {}} >
                                                            <TableCell>
                                                                <Typography variant='h3'><b>{item.nome}</b></Typography>
                                                            </TableCell>
                                                            <TableCell style={(index === saldos.length - 1) ? { color: '#ffffff' } : {}}>
                                                                {(index === saldos.length - 1) ? <Typography variant='h3'><b>{item.qtdanterior}</b></Typography> : <Typography variant='h3'>{item.qtdanterior}</Typography>}
                                                            </TableCell>
                                                            <TableCell style={(index === saldos.length - 1) ? { color: '#ffffff' } : {}}>
                                                                {(index === saldos.length - 1) ? <Typography variant='h3'><b>{item.qtdentradas}</b></Typography> : <Typography variant='h3'>{item.qtdentradas}</Typography>}
                                                            </TableCell>
                                                            <TableCell style={(index === saldos.length - 1) ? { color: '#ffffff' } : {}}>
                                                                {(index === saldos.length - 1) ? <Typography variant='h3'><b>{item.qtdsaidas}</b></Typography> : <Typography variant='h3'>{item.qtdsaidas}</Typography>}
                                                            </TableCell>
                                                            <TableCell style={(index === saldos.length - 1) ? { color: '#ffffff' } : {}}>
                                                                {(index === saldos.length - 1) ? <Typography variant='h3'><b>{item.qtdatual}</b></Typography> : <Typography variant='h3'>{item.qtdatual}</Typography>}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>

                                        </TableContainer>

                                    </Grid>

                                </Paper>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>

                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeBalance() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Balance;